import React, { Component } from "react";
import PopUpForm from "../../../Generic/PopUpDialog/PopUpForm";
import { connect } from "react-redux";
import { API } from "aws-amplify";
import { setRefresh } from "../../../../actions/algoliaActions";
import { setAlgoliaLoaderState } from "../../../../actions/loaderActions";
import config from "../../../../config";

class CreateBlindKassettePopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationTypes: [
        {
          id: "name",
          label: "Kassette Name",
          type: "text",
          tooltip: "Please Enter Blind Style Name",
          required: true,
          value: ""
        },
        {
          id: "height",
          label: "Kassette Height",
          type: "number",
          tooltip: "Please Enter Kassette Height",
          required: false,
          value: ""
        },
        {
          id: "costPerMetre",
          label: "Cost Per Metre",
          type: "number",
          tooltip: "Please Enter Kassette Cost per Metre",
          required: true,
          value: 0
        },
        {
          id: "markup",
          label: "Markup (%)",
          type: "number",
          tooltip: "Please Enter Kassette Markup",
          required: true,
          value: 0
        },
        {
          id: "manufacturerId",
          label: "Manufacturer ID",
          type: "AlgoliaSelect",
          index: `${config.algolia.prefix}manufacturers_name_asc`,
          filters: "isDeleted:false"
        },
        {
          id: "associatedServices",
          label: "Associated Services",
          type: "multiSelect",
          index: `${config.algolia.prefix}products_services_fees_name_asc`,
          value: []
        }
      ]
    };
  }

  APIMethod = async formData => {
    try {
      this.props.dispatch(setAlgoliaLoaderState(true));
      const body = {
        details: {
          name: formData.name,
          height: formData.height,
          costPerMetre: formData.costPerMetre,
          markup: formData.markup,
          associatedServices: formData.associatedServices,
          manufacturerId: formData.manufacturerId
        }
      };
      this.props.history.push(`/products/blinds/kassette`);
      await API.post("telishadeAPI", "/product/blind/component/kassette", {
        body
      });
      this.props.dispatch(setAlgoliaLoaderState(false));
      this.props.dispatch(setRefresh(true));
    } catch (e) {
      this.props.dispatch(setAlgoliaLoaderState(false));
      throw e;
    } finally {
      // Refresh any algolia components currently mounted 1 second after updating
      setTimeout(() => {
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setRefresh(true));
        this.props.dispatch(setRefresh(false));
      }, 0);
    }
  };

  handleCancelClick = () => {
    this.props.history.goBack();
  };

  handleSubmitClick = formData => {
    const body = {
      details: {
        name: formData.name,
        height: formData.height
      }
    };
    return API.post("telishadeAPI", "/product/blind/component/kassette", {
      body
    });
  };

  render() {
    return (
      <PopUpForm
        fields={this.state.validationTypes}
        apiMethod={this.APIMethod}
        header="Add New Blind Kassette"
        button="Accept"
        buttoncolour="green"
        button2="Cancel"
        button2colour="red"
      />
    );
  }
}

export default connect()(CreateBlindKassettePopUp);
